define(['img-comparison-slider'], () => {
    'use strict';
    return () => {};
});
